// extracted by mini-css-extract-plugin
export default {"tableBox":"nABaPj9pikD650wQ_OGS","timeRow":"w9Ey1rMo2q1s1dmDB4rH"};